import React from "react";
import "./index.css";
import Product from "../product";
import { products } from "../../data.js";

const ProductList = () => {
  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Create & inspire. It's Lullaby</h1>
        <p className="pl-desc">
          This is a collection of applications that I have made so far. I hope
          it's useful for you.
        </p>
      </div>
      <div className="pl-list">
        {products.map((item) => (
          <Product key={item.id} img={item.img} link={item.link} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
